import React, { useEffect, useState } from "react";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";
import DefaultButton from "../buttons/defaultButton";
import CommonModal from "../modals/commonModel";
import DefaultSearchSelectInput from "../inputs/defaultSearchSelectInput";

export const getCurrentMonth = () => {
    const today = new Date();
    return today.getMonth() + 1;
};

const isFutureMonth = (selectedDate, allowedMonth) => {
    const currentYear = new Date().getFullYear();
    const selectedYear = selectedDate.getFullYear();
    const selectedMonth = selectedDate.getMonth() + 1;

    // Restrict future years
    if (selectedYear > currentYear) return true;

    // If allowedMonth is passed, restrict access to that month and beyond
    if (allowedMonth && selectedYear === currentYear && selectedMonth >= allowedMonth) {
        return true; // Block same or future months
    }

    return false;
};



// Validate and get correct initial month
const getValidMonthDate = (currentYear, currentMonth, month) => {
    if (typeof month === "number" && month >= 1 && month <= 12 && month <= currentMonth) {
        return new Date(`${currentYear}-${String(month).padStart(2, '0')}-01`);
    }
    return new Date(`${currentYear}-${String(currentMonth).padStart(2, '0')}-01`);
};

const YearMonthFilter = ({ handleChangeDate = () => null, allowedMonth = null }) => {
    const today = new Date(); // Current date
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;
    const [selectedDate, setSelectedDate] = useState(getValidMonthDate(currentYear, currentMonth, allowedMonth));
    const [showModal, setShowModal] = useState(false);

    const isFuture = isFutureMonth(selectedDate, allowedMonth || getCurrentMonth());

    const openModal = () => setShowModal(true);
    const closeModal = () => setShowModal(false);

    useEffect(() => {
        handleChangeDate(selectedDate);
    }, [selectedDate]);

    const formatMonthYear = (date) => {
        const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        return `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
    };

    const handlePrevMonth = () => {
        setSelectedDate((prevDate) => {
            const newDate = new Date(prevDate);
            newDate.setMonth(prevDate.getMonth() - 1);
            return newDate;
        });
    };

    const handleNextMonth = () => {
        if (isFuture) return
        setSelectedDate((prevDate) => {
            const newDate = new Date(prevDate);
            newDate.setMonth(prevDate.getMonth() + 1);
            return newDate;
        });
    };

    const handleApplyFilter = (year, month) => {
        const y = parseInt(year);
        const m = parseInt(month);

        const selectedDate = new Date(`${y}-${String(m).padStart(2, '0')}-01`);
        const future = isFutureMonth(selectedDate, allowedMonth);

        // Invalid input or restricted future month
        if (m < 1 || m > 12 || y !== currentYear || future) {
            handleReset();
        } else {
            setSelectedDate(selectedDate);
            closeModal();
        }
    };

    const handleReset = () => {
        const fallbackMonth = allowedMonth && allowedMonth <= currentMonth ? allowedMonth : currentMonth;
        const fallbackDate = new Date(`${currentYear}-${String(fallbackMonth).padStart(2, '0')}-01`);
        setSelectedDate(fallbackDate);
        closeModal();
    };

    return (
        <div className="flex items-center justify-center text-theme bg-light h-10 px-1 rounded-md w-full">
            <DefaultButton
                classnames={"bg-white"}
                variant="secondary"
                onClick={handlePrevMonth}
                icon={<RiArrowLeftSLine />}
            />

            <div
                onClick={openModal}
                className="font-bold min-w-[160px] w-full m-auto text-center cursor-pointer hover:text-primary-800"
            >
                {formatMonthYear(selectedDate)}
            </div>

            <DefaultButton
                classnames={"bg-white"}
                variant="secondary"
                onClick={handleNextMonth}
                disabled={isFuture}
                icon={<RiArrowRightSLine />}
            />

            <CommonModal
                onClose={closeModal}
                show={showModal}
                headerTitle={"Select Year"}
            >
                <YearModal
                    closeModal={closeModal}
                    defaultYear={selectedDate.getFullYear()}
                    defaultMonth={String(selectedDate.getMonth() + 1).padStart(2, "0")}
                    applyFilter={handleApplyFilter}
                    handleReset={handleReset}
                />
            </CommonModal>
        </div>
    );
};

const YearModal = ({ closeModal, defaultYear, defaultMonth, applyFilter, handleReset }) => {
    const currentYear = new Date().getFullYear();
    const yearOptions = Array.from({ length: 25 }, (_, index) => ({
        label: (currentYear - index).toString(),
        value: (currentYear - index).toString(),
    }));

    const monthOptions = [
        { label: "January", value: "01" }, { label: "February", value: "02" },
        { label: "March", value: "03" }, { label: "April", value: "04" },
        { label: "May", value: "05" }, { label: "June", value: "06" },
        { label: "July", value: "07" }, { label: "August", value: "08" },
        { label: "September", value: "09" }, { label: "October", value: "10" },
        { label: "November", value: "11" }, { label: "December", value: "12" },
    ];

    const [selectedYear, setSelectedYear] = useState(
        yearOptions.find((item) => item?.value === defaultYear.toString())
    );
    const [selectedMonth, setSelectedMonth] = useState(
        monthOptions.find((item) => item?.value === defaultMonth)
    );

    return (
        <div className="flex flex-col gap-2">
            <DefaultSearchSelectInput
                name="year"
                label="Year"
                options={yearOptions}
                value={selectedYear}
                onChange={(value) => setSelectedYear(value)}
            />
            <DefaultSearchSelectInput
                name="month"
                label="Month"
                options={monthOptions}
                value={selectedMonth}
                onChange={(value) => setSelectedMonth(value)}
            />
            <div className="flex justify-start gap-2 mt-4">
                <DefaultButton
                    name="Filter"
                    onClick={() =>
                        applyFilter(selectedYear?.value, selectedMonth?.value)
                    }
                />
                <DefaultButton
                    variant="secondary"
                    name="Reset"
                    onClick={handleReset}
                />
            </div>
        </div>
    );
};

export default YearMonthFilter;

